/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CheckFreshResponseDto } from '../models/CheckFreshResponseDto';
import type { HistoryResponseDto } from '../models/HistoryResponseDto';
import type { SubmitResultResponseDto } from '../models/SubmitResultResponseDto';
import type { SubmitTestDto } from '../models/SubmitTestDto';
import type { TestResultsListResponseDto } from '../models/TestResultsListResponseDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TestResultsService {
    /**
     * @returns SubmitResultResponseDto Результат теста сохранён
     * @throws ApiError
     */
    public static testResultsControllerSubmit({
        id,
        requestBody,
    }: {
        id: string,
        requestBody: SubmitTestDto,
    }): CancelablePromise<SubmitResultResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/tests/{id}/submit',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns TestResultsListResponseDto Результаты по тесту
     * @throws ApiError
     */
    public static testResultsControllerByTest({
        id,
    }: {
        id: string,
    }): CancelablePromise<TestResultsListResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tests/{id}/results',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns HistoryResponseDto История попыток по тесту
     * @throws ApiError
     */
    public static testResultsControllerHistory({
        id,
    }: {
        id: string,
    }): CancelablePromise<HistoryResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tests/{id}/history',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns TestResultsListResponseDto Все результаты пользователя
     * @throws ApiError
     */
    public static testResultsControllerAll(): CancelablePromise<TestResultsListResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tests/results',
        });
    }
    /**
     * @returns TestResultsListResponseDto Результаты с историей (до 5 на тест)
     * @throws ApiError
     */
    public static testResultsControllerAllWithHistory(): CancelablePromise<TestResultsListResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tests/results/all',
        });
    }
    /**
     * @returns CheckFreshResponseDto Какие тесты уже пройдены (свежие)
     * @throws ApiError
     */
    public static testResultsControllerCheckFresh({
        testIds,
    }: {
        testIds: string,
    }): CancelablePromise<CheckFreshResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tests/check-fresh',
            query: {
                'testIds': testIds,
            },
        });
    }
}
